"use client";

import { PropsWithChildren } from "react";
import { useBeforeUnload } from "@/hooks";

export function SaveWarningProvider({ children }: PropsWithChildren) {
    return <useBeforeUnload.Provider>{children}</useBeforeUnload.Provider>;
}
